import styled, { keyframes } from "styled-components";
const cardAnimation = keyframes`

from{transform:scale(1) rotateY(0)}  
to{
transform:rotate(4.15429deg) rotateX(40deg) scale(0.4, 0.4)
}`;

export const IndexFeaturesComponentMainDiv = styled.section`

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 40px;
    gap: 60px;
    width: 100%;
  }
  .feature-header-container {
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: center;
  }
  .feature-header-text-container {
    max-width: 736px;
    text-align: center;
    > p {
      font-size: 18px;
      line-height: 1.4em;
      font-weight: 400;
    }
  }
  .feature-header {
    display: flex;
    gap: 24px;
    flex-direction: column;
  }
  .feature-container {
    max-width: 1140px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 100px;
    position: relative;
    perspective: 1200px;
  }
`;

interface IndexFeaturesComponentItemProp {
  index: number;
}
export const IndexFeaturesComponentItem = styled.div<IndexFeaturesComponentItemProp>`
  background: black;

  border: 1px solid rgb(25, 25, 25);
  position: sticky;
  top: 100px;
  animation: ${cardAnimation} linear;
  animation-timeline: view();
  animation-range: cover ${p => Math.min(Math.max(p.index * 5 + 30, 30), 60)}% cover 100%;
  transform: perspective(1200px);
  > div {
    display: flex;
    gap: 60px;
    padding: 16px;
    align-items: center;
    flex-direction:${p => (p.index %2)===0? "row-reverse":"row" };
  }
  .index-items-feature-list-container {
    flex: 1;
    display: flex;
    gap: 32px;
    padding: 0 0 0 44px;
    flex-direction: column;
  }
  .index-items-feature-image-container {
    flex: 1;
    min-height: 40px;
  }
  .index-items-feature-text-container {
    > h3 {
      font-size: 44px;
      font-weight: 500;
      font-family: " General Sans", "General Sans Placeholder", sans-serif;

      line-height: 1.1em;
      padding: 0;
      margin: 0;
    }
    > p {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.5em;
      padding: 0;
      font-family: Inter, "Inter Placeholder", sans-serif;
      margin: 0;
      color: #cccccc;
    }
  }
  .index-items-feature-list-header-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .feature-list-bullet-point {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .feature-list-bullet-point-text {
    > p {
      font-size: 18px;
      font-weight: 500;
      line-height: 1.1em;
      padding: 0;
      margin: 0;
    }
  }
  .feature-list-bullet-point-icon {
    border: 1px solid rgb(25, 25, 25);
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    > div {
      width: 24px;
      height: 24px;
      > svg {
             fill: url(#shinyTransparentGray);

        width: 24px;
        height: 24px;
      }
    }
  }
  .feature-list-bullet-point-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const IndexFeaturesComponentImageDiv = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  border-radius: 8px;
  border: 1px solid red;
  height: 494px;
`;
